import {
  EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA,
  EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT,
  EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT_WITH_SELLER_PROMOTIONS,
} from '../../../../../experiments/eventTracking/EXPERIMENTS_TRACK_EVENT'
import { experimentsTrackEvent } from '../../../../../experiments/eventTracking/experimentsTrackEvent'
import { usePdpBuyTogetherRecommendationTracking } from '../../../../../experiments/experiment-pdp-buy-together-recommendation/usePdpBuyTogetherRecommendationTracking'
import { useExperimentRemoveBannersTracking } from '../../../../../experiments/experiment-remove-banners/useExperimentRemoveBannersTracking.ts'
import { productAccessorIsSaeOffer } from '../../../../model/productAccessor/productAccessorIsSaeOffer'
import { productAccessorOfferHasSellerPromotion } from '../../../../model/productAccessor/productAccessorOfferHasSellerPromotion'
import { useProductPageContext } from '../../../productPageContext'

export const useProductAddToCartButtonTracking = (): (() => void) => {
  const { currentOffer, product } = useProductPageContext()

  const trackAddToCartButtonMarketPlaceProduct = (): void => {
    const isMarketPlace =
      currentOffer && !productAccessorIsSaeOffer(currentOffer)

    if (!isMarketPlace) {
      return
    }

    const productOfferHasSellerPromotion =
      productAccessorOfferHasSellerPromotion(currentOffer)

    experimentsTrackEvent(EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT)

    if (productOfferHasSellerPromotion) {
      experimentsTrackEvent(
        EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT_WITH_SELLER_PROMOTIONS,
      )
    }
  }

  const experimentRemoveBannersTracking = useExperimentRemoveBannersTracking(
    EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA,
  )
  const trackPdpBuyTogetherRecommendationAddToCartButton =
    usePdpBuyTogetherRecommendationTracking(
      EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA,
      { currentOffer, product },
    )

  return (): void => {
    trackAddToCartButtonMarketPlaceProduct()
    experimentRemoveBannersTracking()
    trackPdpBuyTogetherRecommendationAddToCartButton()
  }
}
